<svelte:options tag={null} />

<script lang="ts">
  import type { TagSize, TagType } from './tag.types';
  import { EventHandler } from '../../utilities/EventHandler';

  export let label: string;
  export let size: TagSize = 'm';
  export let dark: boolean;
  export let type: TagType = 'text';
  export let disabled: boolean;
  export let id: string;
  export let href: string;
  export let name: string;
  export let selected = false;

  $: isSelected = selected ? true : false;
  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;

  let eventHandler = new EventHandler();

  function getClasses(type: TagType) {
    const classes = [`mc-tag-${type}`];

    if (size) {
      classes.push(`mc-tag-${type}--${size}`);
    }

    if (dark) {
      classes.push(`mc-tag-${type}--dark`);
    }

    return classes.join(' ');
  }

  function getSubClasses(type: TagType, element: string) {
    return `mc-tag-${type}__${element}`;
  }

  function onSelect(): void {
    isSelected = !isSelected;
    eventHandler.dispatch('tag-selected', isSelected);
  }

  function onRemoved(): void {
    eventHandler.dispatch('tag-removed', { id, label });
  }
</script>

{#if type === 'text'}
  <span class="{getClasses(type)}  {userClass}" {...attributes}>
    <span class={getSubClasses(type, 'label')}>
      {label}
    </span>
  </span>
{/if}
{#if type === 'link'}
  <a
    {href}
    class="{getClasses(type)}  {userClass}"
    on:click={onSelect}
    {...attributes}
  >
    <span class={getSubClasses(type, 'label')}>
      {label}
    </span>
  </a>
{/if}
{#if type === 'selectable'}
  <span
    class="{getClasses(type)}  {userClass}"
    on:click={onSelect}
    {...attributes}
  >
    <input
      class={getSubClasses(type, 'input')}
      type="checkbox"
      {name}
      checked={isSelected}
      {id}
      {disabled}
    />
    <label class={getSubClasses(type, 'pill')} for={id}>
      <span class={getSubClasses(type, 'label')}>
        {label}
      </span>
    </label>
  </span>
{/if}
{#if type === 'removable'}
  <span class="{getClasses(type)}  {userClass}" {...attributes}>
    <span class={getSubClasses(type, 'label')}>
      {label}
    </span>
    <button class={getSubClasses(type, 'remove')} on:click={onRemoved}>
      <span class={getSubClasses(type, 'remove-text')}> {label} </span>
    </button>
  </span>
{/if}

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.tag';
</style>
